let LOCAL_API_PATH = 'https://api.nuggets.live/';
let LOCAL_BUILDER_PATH = 'https://dev.nuggets.live/builder/index.html?';
let LOCAL_PUB_PLAYER_PATH = 'https://dev.nuggets.live/player/';
let LOCAL_UNPUB_PLAYER_PATH = 'https://dev.nuggets.live/player/?';
/*

if(window.location.hostname === 'localhost') {
    //LOCAL_API_PATH= 'http://localhost/agencyvignets/vignetsapi/public/';
    LOCAL_API_PATH= 'https://vigapiv1.vignets.com/';
    LOCAL_BUILDER_PATH = 'https://agency.vignets.com/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://a.vignets.com/publish/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://a.vignets.com/player/?';
}
else if(window.location.hostname === 'devagency.vignets.com') {
    LOCAL_API_PATH= 'https://devvigapiv1.vignets.com/';
    LOCAL_BUILDER_PATH = 'https://devagency.vignets.com/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://devagency.vignets.com/publish/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://devagency.vignets.com/player/?';
}
else if(window.location.hostname === 'seo.vignets.com' || window.location.hostname === 'seo.vignets.com:8080' ) {
    LOCAL_API_PATH= 'https://devvigapiv1.vignets.com/';
    LOCAL_BUILDER_PATH = 'https://seo.vignets.com:8080/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://seo.vignets.com:8080/publish/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://seo.vignets.com:8080/player/?';
}
else if(window.location.hostname === 'v.labsls.com') {
    LOCAL_API_PATH= 'https://vapi.labsls.com/';
    LOCAL_BUILDER_PATH = 'https://v.labsls.com/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://v.labsls.com/publish/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://v.labsls.com/player/?';
}
else{
    LOCAL_API_PATH= 'https://vigapiv1.vignets.com/';
    LOCAL_BUILDER_PATH = 'https://agency.vignets.com/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://a.vignets.com/publish/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://a.vignets.com/player/?';
}
*/

export const API_PATH = LOCAL_API_PATH;
export const BUILDER_PATH = LOCAL_BUILDER_PATH;
export const PUB_PLAYER_PATH = LOCAL_PUB_PLAYER_PATH;
export const UNPUB_PLAYER_PATH = LOCAL_UNPUB_PLAYER_PATH;

console.log(window.location.hostname);

export const  IMG_PATH = 'https://s3cdn.vignets.com/';
export const  IMGIX_PATH = 'https://vignets.imgix.net/';
export const  BUCKET_PATH = 'https://lexplainer.s3.amazonaws.com/';



export const  BUCKET_NAME = 'lexplainer';
export const  ALBUM_NAME = 'assets/slider';
export const  REGION = 'us-east-1';
export const  ACCESS_KEY_ID = 'AKIARFKGTHVQI23WX22J';
export const  SECRET_ACCESS_KEY = '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';



// WEBPACK FOOTER //
// ./src/constants/index.js